module.exports = __webpack_public_path__ + "static/img/yy2.ff5a6d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yy2.png
// module id = xA47
// module chunks = 1